import {useState, useEffect, useRef} from "react";
import { Button, Result } from 'antd';

import {ReactComponent as ShowIcon} from "./showIcon.svg";
import {ReactComponent as HideIcon} from "./hideIcon.svg";
import {ReactComponent as EditIcon} from "./editBlock.svg";
import {ReactComponent as CancelIcon} from "./cancel.svg";
import {ReactComponent as CalendarIcon} from "./calendarIcon.svg";
import {ReactComponent as TimeIcon} from "./timeIcon.svg";

import {updateById} from "../../../shared/services/missions";

import EditInput from "./EditInput";

import styles from "./mission-card.module.scss";

import missionCategories from "./mission-categories"

const isArchive = ({archive_c, archive_d, archive_e}) => (archive_c + archive_d + archive_e) > 0;

const MissionCard = (props) => {
    const [edit, setEdit] = useState(null);
    const [data, setData] = useState(props);
    const [newData, setNewData] = useState(null);
    const [save, setSave] = useState(false);
    const [openBlocks, setOpenBlocks] = useState([])

    const firstRender = useRef(true);

    useEffect(() => {
        if (firstRender.current) {
            firstRender.current = false;
            return;
        }
        const updateData = async () => {
            const result = await updateById(props.id, newData);
            setData(prevState => ({...prevState, ...newData}))
            setSave(false);
            setEdit(null)

        };
        if (save) {
            updateData();
        }

    }, [save]);

    const onSave = (id) => {
        setSave(true);
    }

    const onEdit = (id) => {
        if (id === 1) {
            const {mission_title, event_date, company_name, company_website, email, phone} = data;
            setNewData({mission_title, event_date, company_name, company_website, email, phone});
            setEdit(1);
            return;
        }
        if(id === 4) {
            const {expenses_data, expenses_transport, expenses_other, expenses_other_descr} = data;
            setNewData({expenses_data, expenses_transport, expenses_other, expenses_other_descr});
            setEdit(4);
            return;
        }
    }

    const onChange = ({target}) => {
        const {name, value} = target;
        setNewData(prevState => ({...prevState, [name]: value}))
    }

    const addOpenBLock = (id) => {
        setOpenBlocks(prevState => [...prevState, id])
    }

    const removeOpenBLock = (id) => {
        setOpenBlocks(prevState => prevState.filter(item => item !== id))
    }

    const {
        mission_title,
        category,
        time_hours,
        time_minutes,
        address,
        street,
        event_date,
        company_name,
        company_website,
        email,
        phone,
        descr,
        user,
        delegate,
        expenses_data,
        expenses_transport,
        expenses_other,
        expenses_other_descr,
    } = data;
    const {status, setStatus} = props;

    const expectedHours = time_hours < 10 ? `0${time_hours}` : time_hours;
    const expectedTime = time_minutes < 10 ? `0${time_minutes}` : time_minutes;

    const {dragStartHandler, dragEndHandler, dragOverHandler, dropHandler} = props;

    return (
        <div className={styles.card} draggable={true}
             id={status}
            onDragStart={(e) => dragStartHandler(e, data)}
            onDragLeave={dragEndHandler}
             onDragEnd={dragEndHandler}
             onDragOver={dragOverHandler}
             onDrop={(e) => dropHandler(e, data)}
        >
            <div className={styles.block}>
                {edit === 1 && (
                    <form id="edit-1">
                        <div className={styles.editHeading}>
                            <span onClick={() => onSave("edit-1")} className={styles.save}>Save</span>
                            <CancelIcon onClick={() => setEdit(null)} className={styles.cancel}/>
                        </div>
                        <EditInput onChange={onChange} name="mission_title" value={newData.mission_title}
                                   placeholder="misson title" label="misson title"/>
                        <EditInput onChange={onChange} name="event_date" value={newData.event_date}
                                   placeholder="Event date" label="Event date"/>
                        <EditInput onChange={onChange} name="company_name" value={newData.company_name}
                                   placeholder="Company name" label="Company name"/>
                        <EditInput onChange={onChange} name="company_website" value={newData.company_website}
                                   placeholder="Website" label="Website"/>
                        <EditInput onChange={onChange} name="email" value={newData.email} placeholder="Email" label="Email"/>
                        <EditInput onChange={onChange} name="phone" value={newData.phone} placeholder="Phone" label="Phone"/>
                    </form>
                )}
                {edit !== 1 && (
                    <>
                        {!openBlocks.includes(1) && <ShowIcon onClick={()=> addOpenBLock(1)} className={styles.topIcon} />}
                        {openBlocks.includes(1) && <HideIcon onClick={()=> removeOpenBLock(1)} className={styles.topIcon} />}
                        <p className={styles.title}>{mission_title}</p>
                        {openBlocks.includes(1) && (
                            <>
                            <p className={styles.subTitle}>{missionCategories[category]}</p>
                            <div className={styles.row}>
                            <div className={styles.rowName}><CalendarIcon className={styles.icon}/> {event_date}</div>
                            <div className={styles.rowValue}></div>
                            </div>
                            <div className={styles.row}>
                            <div className={styles.rowName}>Exp. Duration:</div>
                            <div className={styles.rowValue}>{`${expectedHours}:${expectedTime}`}</div>
                            </div>
                            <div className={styles.row}>
                            <div className={styles.rowName}>Address:</div>
                            <div className={styles.rowValue}>{`${address}, ${street}`}</div>
                            </div>
                            <div className={styles.row}>
                            <div className={styles.rowName}>Company name:</div>
                            <div className={styles.rowValue}>{company_name}</div>
                            </div>
                            <div className={styles.row}>
                            <div className={styles.rowName}>Website:</div>
                            <div className={styles.rowValue}>{company_website}</div>
                            </div>
                            <div className={styles.row}>
                            <div className={styles.rowName}>email:</div>
                            <div className={styles.rowValue}>{email}</div>
                            </div>
                            <div className={styles.row}>
                            <div className={styles.rowName}>Phone:</div>
                            <div className={styles.rowValue}>{phone}</div>
                            </div>
                                {(status < 7 && !isArchive(props)) && (
                                    <div className={styles.editIcon}>
                                        <EditIcon onClick={() => onEdit(1)} />
                                    </div>
                                )}
                            </>
                        )}

                    </>
                )}
            </div>
            <div className={styles.block}>
                {!openBlocks.includes(2) && <ShowIcon onClick={()=> addOpenBLock(2)} className={styles.topIcon} />}
                {openBlocks.includes(2) && <HideIcon onClick={()=> removeOpenBLock(2)} className={styles.topIcon} />}
                <p className={styles.title}>Client</p>
                {openBlocks.includes(2) && (
                    <>
                        <p className={styles.subTitle}>{`${user.first_name} ${user.last_name}`}</p>
                        <div className={styles.row}>
                            <div className={styles.rowName}>Client company:</div>
                            <div className={styles.rowValue}>{user.company_name}</div>
                        </div>
                        <div className={styles.row}>
                            <div className={styles.rowName}>Address:</div>
                            <div className={styles.rowValue}>{user.address}</div>
                        </div>
                        <div className={styles.row}>
                            <div className={styles.rowName}>Email:</div>
                            <div className={styles.rowValue}>{user.email}</div>
                        </div>
                        <div className={styles.row}>
                            <div className={styles.rowName}>Phone:</div>
                            <div className={styles.rowValue}>{user.phone}</div>
                        </div>
                    </>)}
            </div>
            {delegate && (
                <div className={styles.block}>
                    {!openBlocks.includes(3) && <ShowIcon onClick={()=> addOpenBLock(3)} className={styles.topIcon} />}
                    {openBlocks.includes(3) && <HideIcon onClick={()=> removeOpenBLock(3)} className={styles.topIcon} />}
                    <p className={styles.title}>Delegate</p>
                    {openBlocks.includes(3) && (
                        <>
                            <p className={styles.subTitle}>{`${delegate.first_name} ${delegate.last_name}`}</p>
                            <div className={styles.row}>
                                <div className={styles.rowName}>Address:</div>
                                <div className={styles.rowValue}>{delegate.address}</div>
                            </div>
                            <div className={styles.row}>
                                <div className={styles.rowName}>Email:</div>
                                <div className={styles.rowValue}>{delegate.email}</div>
                            </div>
                            <div className={styles.row}>
                                <div className={styles.rowName}>Phone:</div>
                                <div className={styles.rowValue}>{delegate.phone}</div>
                            </div>
                        </>)}
                </div>
            )}
            <div className={styles.block}>
                {edit === 4 && (
                    <form id="edit-4">
                        <div className={styles.editHeading}>
                            <span onClick={() => onSave("edit-4")} className={styles.save}>Save</span>
                            <CancelIcon onClick={() => setEdit(null)} className={styles.cancel}/>
                        </div>
                        <EditInput onChange={onChange} name="expenses_transport" value={newData.expenses_transport}
                                   placeholder="Expenses transport" label="Expenses transport"/>
                        <EditInput onChange={onChange} name="expenses_data" value={newData.expenses_data}
                                   placeholder="Internet etc" label="Internet etc"/>
                        <EditInput onChange={onChange} name="expenses_other" value={newData.expenses_other}
                                   placeholder="Other" label="Other"/>
                        <EditInput onChange={onChange} name="expenses_other_descr" value={newData.expenses_other_descr}
                                   placeholder="Other details" label="Other details"/>
                    </form>
                )}
                {edit !== 4 && (
                    <>
                        {!openBlocks.includes(4) && <ShowIcon onClick={()=> addOpenBLock(4)} className={styles.topIcon} />}
                        {openBlocks.includes(4) && <HideIcon onClick={()=> removeOpenBLock(4)} className={styles.topIcon} />}
                        <p className={styles.title}>Invoice</p>
                        {openBlocks.includes(4) && (
                            <>
                                <div className={styles.row}>
                                    <div className={styles.rowName}>Transport:</div>
                                    <div className={styles.rowValue}>{String(expenses_transport)}</div>
                                </div>
                                <div className={styles.row}>
                                    <div className={styles.rowName}>Internet etc:</div>
                                    <div className={styles.rowValue}>{String(expenses_data)}</div>
                                </div>
                                <div className={styles.row}>
                                    <div className={styles.rowName}>Other:</div>
                                    <div className={styles.rowValue}>{String(50)}</div>
                                </div>
                                <div className={styles.row}>
                                    <div className={styles.rowName}>Other details:</div>
                                    <div className={styles.rowValue}>{String(expenses_other_descr)}</div>
                                </div>
                                <div className={styles.row}>
                                    <div className={styles.rowName}>Expected payment for mission:</div>
                                    <div className={styles.rowValue}>{String(Number(data.expected_hours) * 50 + Number(expenses_transport) + Number(expenses_data) + 50)}</div>
                                </div>
                                {(status > 0 && status < 7 && !isArchive(props)) && (
                                    <div className={styles.editIcon}>
                                        <span className={styles.showInvoice} onClick={props.showInvoice}>Show invoice</span>
                                        <EditIcon className={styles.cursor} onClick={() => onEdit(4)} />
                                    </div>
                                )}
                            </>
                        )}
                    </>
                )}
            </div>
            {(status === 2 || status === 3) && (
                <div className={styles.btnWrapper}>
                    {status === 2 && (
                        <Button type="default" style={{borderRadius: "4px"}}>
                            Mission accepted
                        </Button>
                    )}

                    {status === 3 && (
                        <>
                            <span></span>
                            <Button type="default" danger style={{borderRadius: "4px"}}>
                                Mission declined
                            </Button>
                        </>
                    )}
                </div>
            )}

            {(status === 7 || status === 8) && (
                <div className={styles.btnWrapper}>
                    {status === 7 && (
                        <>
                            <Result status="success" title="Client confirms" />
                            <Button type="default" onClick={()=> setStatus(8)} danger style={{borderRadius: "4px", cursor: "pointer"}}>
                                Switch to declined
                            </Button>
                        </>
                    )}

                    {status === 8 && (
                        <>
                            <Result status="error" title="Client declined" />
                            <Button type="default" onClick={()=> setStatus(7)} style={{borderRadius: "4px", cursor: "pointer", color: "#52c41a", borderColor: "#52c41a"}}>
                                Switch to confirms
                            </Button>
                        </>
                    )}
                </div>
            )}
        </div>
    )
}

export default MissionCard;
